<template>
  <v-text-field
    :value="value"
    @input="$emit('input', $event)"
    dense
    rounded
    outlined
    clearable
    hide-details
    class="mx-2"
    style="max-width: 420px;"
    prepend-inner-icon="mdi-magnify"
    placeholder="Search products"
  />
</template>

<script>
export default {
  name: "RemoteStoreSearchBar",
  props: { value: { type: String, default: "" } },
};
</script>